import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { Question } from './Question';

export class DateQuestionInternal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: undefined,
    };
  }

  onChange = (date) => {
    this.setState({ selectedDate: date });
    this.props.updateAnswer(this.props.questionnaireItem.questionnaireItemId, date);

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  render() {
    const isClearable = true;
    const { questionnaireItem, dateQuestionLabel } = this.props;
    const opts = {};
    opts.disabled = this.props.disabled;
    opts.placeholderText = this.props.disabled ? '' : dateQuestionLabel;
    if (this.props.answerItem) {
      opts.placeholderText = (moment(this.props.answerItem.dateAnswer).format('MMM DD, YYYY'));
    }
    return (
      <div data-qa-item="date_question_type" className="question-area">
        <Question questionNumber={questionnaireItem.questionNumber}
          isValid={ questionnaireItem.isValid }
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <div className="row">
          <div className="col-sm-4">
            <div className={this.props.questionnaireItem.isValid === false ? 'form-group has-error is-invalid' : 'form-group'}>
              <div className="input-group date">
              <DatePicker name="datePicker"
                dateFormat="MMM d, yyyy"
                className="form-control"
                locale={this.props.language}
                selected={this.state.selectedDate}
                onChange={this.onChange}
                isClearable={isClearable}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                {...opts}
              />
              </div>
            </div>
            {
                questionnaireItem.isValid === false
                  ? <span data-qa-item={ 'question_is_invalid_' + questionnaireItem.questionNumber } className="invalid-feedback">
                  <FormattedMessage {...messages.error.required} />
                </span>
              : null
              }
          </div>
        </div>
      </div>
    );
  }
}

DateQuestionInternal.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  language: PropTypes.string,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
  dateQuestionLabel: PropTypes.string,
};